import fp from 'lodash/fp'
import { combine, withState, withCallback } from 'react-hooks-combine'

import StringListCellComponent from './component'

const DEFAULT_ITEMS_COUNT = 2

export const StringListCell = combine({
  hooks: [
    withState('showMore', 'toggleMore', false),

    withCallback(
      'onToggleVisibility',
      ({ toggleMore }) =>
        () => {
          toggleMore((showMore) => !showMore)
        },
      []
    ),
  ],

  transformProps: ({
    value,
    valueTransformer = fp.identity,
    onToggleVisibility,
    showMore,
  }) => {
    const empty = value == null || value.length === 0
    const longerThanExpected = value?.length > DEFAULT_ITEMS_COUNT
    const itemsCount =
      showMore && longerThanExpected ? Infinity : DEFAULT_ITEMS_COUNT
    const items = fp.map(valueTransformer, value)

    return {
      empty,
      showMore,
      longerThanExpected,
      onToggleVisibility,
      tooltip: fp.join(', ', items),
      value: fp.take(itemsCount, items),
    }
  },
})(StringListCellComponent)
